<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.stoppageCode" clearable placeholder="单号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.reason" clearable placeholder="原因" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button icon="el-icon-data-analysis" @click="loadStats">统计</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="stoppageCode" label="单号" width="180" />
      <el-table-column prop="productionLineName" label="产线" width="140" show-overflow-tooltip />
      <el-table-column prop="machineName" label="设备" width="140" show-overflow-tooltip />
      <el-table-column prop="orderCode" label="工单" width="140" />
      <el-table-column prop="reasonName" label="原因" min-width="140" show-overflow-tooltip />
      <el-table-column prop="startTime" label="开始" width="170" />
      <el-table-column prop="endTime" label="结束" width="170" />
      <el-table-column prop="durationMin" label="分钟" width="90" align="right" />
      <el-table-column label="操作" width="180" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button v-if="!row.endTime" type="text" @click="doFinish(row)">结束</el-button>
          <el-button type="text" @click="openEdit(row.stoppageId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="form.stoppageId ? '修改停机' : '新增停机'" :visible.sync="visible" width="680px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="单号">
          <el-input v-model="form.stoppageCode" placeholder="留空自动生成" />
        </el-form-item>
        <el-form-item label="产线">
          <el-select v-model="form.productionLineId" filterable clearable style="width:100%" @change="onLineChange">
            <el-option v-for="item in lineOptions" :key="item.lineId" :label="item.lineName" :value="item.lineId" />
          </el-select>
        </el-form-item>
        <el-form-item label="设备">
          <el-select v-model="form.machineId" filterable clearable style="width:100%">
            <el-option
              v-for="item in machineOptions"
              :key="item.machineId"
              :label="(item.machineCode || '') + ' / ' + (item.machineName || '')"
              :value="item.machineId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="工单">
          <el-select v-model="form.orderId" filterable clearable style="width:100%">
            <el-option
              v-for="item in orderOptions"
              :key="item.orderId"
              :label="(item.orderCode || '') + ' / ' + (item.orderName || '')"
              :value="item.orderId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="停机原因">
          <el-select v-model="form.reasonId" filterable clearable style="width:100%" @change="onReasonChange">
            <el-option
              v-for="item in reasonOptions"
              :key="item.reasonId"
              :label="(item.reasonCode || '') + ' / ' + (item.reasonName || '')"
              :value="item.reasonId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="原因备注">
          <el-input v-model="form.reason" placeholder="可选补充说明" />
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker v-model="form.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="form.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
        </el-form-item>
        <el-form-item label="时长(分钟)">
          <el-input-number v-model="form.durationMin" :min="0" :precision="2" style="width:100%" />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="form.description" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="停机统计(按产线)" :visible.sync="statsVisible" width="560px">
      <el-table :data="statsList" border size="small">
        <el-table-column prop="productionLineName" label="产线" />
        <el-table-column prop="stoppageCount" label="次数" width="90" align="right" />
        <el-table-column prop="totalDurationMin" label="合计分钟" width="120" align="right" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listStoppage, getStoppage, saveStoppage, updateStoppage, deleteStoppage, finishStoppage, statsStoppage } from '../../api/stoppage'
import { selectProductionLine } from '../../api/productionLine'
import { selectProductionOrder } from '../../api/productionOrder'
import { selectStoppageReason } from '../../api/stoppageReason'
import { selectMachine } from '../../api/machine'

function emptyForm() {
  return {
    stoppageId: '', stoppageCode: '', productionLineId: '', machineId: '', orderId: '',
    reasonId: '', reason: '', startTime: '', endTime: '', durationMin: undefined, description: '', version: 0
  }
}

export default {
  name: 'StoppagePage',
  components: { ListPagination },
  data() {
    return {
      query: { stoppageCode: '', reason: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false, form: emptyForm(),
      lineOptions: [], machineList: [], orderOptions: [], reasonOptions: [],
      statsVisible: false, statsList: []
    }
  },
  computed: {
    machineOptions() {
      if (!this.form.productionLineId) return this.machineList
      const matched = this.machineList.filter(m => m.productionLineId === this.form.productionLineId)
      return matched.length ? matched : this.machineList
    }
  },
  created() {
    selectProductionLine().then(res => { this.lineOptions = res.data || [] }).catch(() => {})
    selectMachine().then(res => { this.machineList = res.data || [] }).catch(() => {})
    selectProductionOrder().then(res => { this.orderOptions = res.data || [] }).catch(() => {})
    selectStoppageReason().then(res => { this.reasonOptions = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listStoppage({
        currentPage: this.page, pageSize: this.pageSize,
        stoppageCode: this.query.stoppageCode, reason: this.query.reason
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    onLineChange(lineId) {
      const current = this.machineList.find(m => m.machineId === this.form.machineId)
      if (current && lineId && current.productionLineId && current.productionLineId !== lineId) {
        this.form.machineId = ''
      }
    },
    onReasonChange(id) {
      const item = (this.reasonOptions || []).find(x => x.reasonId === id)
      if (item) this.form.reason = item.reasonName
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      if (!id) return
      getStoppage(id).then(res => { this.form = Object.assign(emptyForm(), res.data || {}) })
    },
    submit() {
      this.saving = true
      const req = this.form.stoppageId ? updateStoppage(this.form) : saveStoppage(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    doFinish(row) {
      this.$confirm('结束该停机？将按当前时间计算时长。', '提示', { type: 'warning' }).then(() => {
        finishStoppage({ stoppageId: row.stoppageId, version: row.version }).then(() => {
          this.$message.success('已结束')
          this.load()
        })
      }).catch(() => {})
    },
    onDelete(row) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteStoppage([row.stoppageId]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    },
    loadStats() {
      statsStoppage({}).then(res => {
        this.statsList = res.data || []
        this.statsVisible = true
      })
    }
  }
}
</script>
